<template>
  <div class="wrapper">
    <section class="page-not-fount-content pt-5 pb-2">
      <h1 class="page-not-fount-title mb-1 mt-5">404</h1>
      <p class="text-below-title my-1">
        {{ $t('pageNotFound.pageNotFound') }}
      </p>
      <router-link
        to="/pulpit"
        class="f-btn f-btn-primary my-2">
        {{ $t('pageNotFound.backToDashboard') }}
      </router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'page-not-found'
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.page-not-fount-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  .page-not-fount-title {
    color: $color-secondary;
    font-size: 21rem;
    line-height: 1.2;
  }

  .text-below-title {
    color: $color-secondary-disabled;
    font-size: 4rem;
  }
}
</style>
